import styled from 'styled-components';
import { FabricationContainer } from '../../../styles';
import { ExtraItensInputContainer } from '../../styles';

export const Container = styled(FabricationContainer)`
  & > header {
    margin-bottom: 1.75rem;

    & > .title {
      font-size: 1.125rem;
      font-weight: 700;
    }

    & > .description {
      font-size: 0.875rem;
    }
  }

  & > div.modal-content {
    display: flex;
    gap: 1rem;
    width: 100%;
  }

  & > div.content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: row;
    }
  }
`;

export const PieceTypesInputContainer = styled(ExtraItensInputContainer)`
  margin-bottom: 0.4375rem;
  width: 100%;
  min-width: unset;

  &.large-input {
    margin-top: 0.3rem;
  }
`;

export const PieceTypesModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 17rem;

    &:last-child {
      width: 60%;
    }
  }

  &.right-block {
    display: flex;
    flex-direction: column-reverse;
    width: auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: unset;
    }
  }
`;

export const MeasureBlock = styled.div`
  display: flex;
  margin-top: 0.4375rem;

  & > .image-block {
    margin-right: 1.125rem;
  }

  & > .inputs {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 0;
  }
`;

export const StepperLabel = styled.span`
  line-height: 1.5rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: 400;
  font-size: 0.875rem;
`;
